module.exports = __webpack_public_path__ + "img/post3.39fece1e.jpeg";